import { ReactNode } from "react";

import "./style.scss";

const EmptyLeftMenuLayout = ({
    children,
    leftMenu
}: {
    children: ReactNode;
    leftMenu?: ReactNode;
}) => {
    return (
        <div className="left-menu-layout">
            {!!leftMenu && (
                <a href="#main-content" className="skip-to-content">
                    Skip to main content
                </a>
            )}
            {!!leftMenu && <div className="second-left-menu">{leftMenu}</div>}
            <main
                id="main-content"
                tabIndex={-1}
                className={`children-content${leftMenu ? "" : " children-content--full"}`}
            >
                {children}
            </main>
        </div>
    );
};

export default EmptyLeftMenuLayout;
